import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

export default function ProjectImage({
  index = 0,
  image,
  handleImageClick,
  isProjectThumb = false,
  size = 'md',
}) {
  const imageNode = getImage(image)
  return (
    <GatsbyImage
      image={imageNode}
      objectFit={isProjectThumb ? 'cover' : 'contain'}
      alt=""
      className={`cursor-pointer ${
        isProjectThumb ? 'w-full' : 'h-full ' + size
      }`}
      style={{
        maxHeight: isProjectThumb ? '70vh' : '80vh',
      }}
      onClick={() => {
        handleImageClick && handleImageClick(index)
      }}
    />
  )
}
